import type { TruckTrackForm } from "@/entity/logistics/track";
import type { TruckArchiveLoader, TruckLocationLoader, TruckTrackLoader } from "./types";

/** 查车档案接口沿用 Vue getLicenseInfo(vclN) 参数。 */
export const loadTruckArchives: TruckArchiveLoader = async vclN => {
    const { vehicleService } = await import("@/api/services/vehicleService");
    return vehicleService.getLicenseInfo(vclN);
};

/** 车辆实时位置接口沿用 Vue vclN_vclColor 组合参数。 */
export const loadTruckLocation: TruckLocationLoader = async vclNAndColor => {
    const { vehicleService } = await import("@/api/services/vehicleService");
    return vehicleService.getTransTimeManage(vclNAndColor);
};

/** 车辆历史轨迹接口沿用 Vue TruckTrackForm 字段。 */
export const loadTruckTrack: TruckTrackLoader = async (form: TruckTrackForm) => {
    const { vehicleService } = await import("@/api/services/vehicleService");
    return vehicleService.getRouterPath(form);
};
